"use strict";
'kiwi public';
/** @module */

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = chathistoryMiddleware;

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/typeof"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _create = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/create"));

var Misc = _interopRequireWildcard(require("@/helpers/Misc"));

/**
 * Adds the CHATHISTORY IRCv3 spec to irc-framework
 */
function chathistoryMiddleware() {
  return function middleware(client, rawEvents, parsedEvents) {
    client.requestCap('CHATHISTORY');
    addFunctionsToClient(client);
    parsedEvents.use(theMiddleware);
  };

  function theMiddleware(command, event, client, next) {
    if (command.toLowerCase() === 'batch end chathistory' && client.chathistory) {
      var target = event.params[0];
      client.chathistory.batchCallbacks.resolve(target, event);
    }

    if (command.toLowerCase() === 'fail' && event.params[0].toLowerCase() === 'chathistory') {
      // FAIL CHATHISTORY MESSAGE_ERROR the_given_command #target :Messages could not be ...
      if (event.params[1].toLowerCase() === 'message_error') {
        client.chathistory.batchCallbacks.resolve(event.params[3]);
      }
    }

    next();
  }
}

function addFunctionsToClient(client) {
  var history = client.chathistory = {};
  history.batchCallbacks = {
    callbacks: (0, _create.default)(null),
    add: function add(target, cb) {
      this.callbacks[target.toLowerCase()] = this.callbacks[target.toLowerCase()] || [];
      this.callbacks[target.toLowerCase()].push(cb);
    },
    resolve: function resolve(target, value) {
      var cbs = this.callbacks[target.toLowerCase()] || [];
      delete this.callbacks[target.toLowerCase()];
      (0, _forEach.default)(cbs).call(cbs, function (cb) {
        return cb(value);
      });
    },
    targetCallbacks: function targetCallbacks(target) {
      return this.callbacks[target.toLowerCase()];
    }
  };

  history.isSupported = function () {
    return !!client.network.supports('chathistory');
  };

  history.before = function (target, dateOrTime) {
    return new _promise.default(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }

      client.raw('CHATHISTORY', 'BEFORE', target, messageReference(dateOrTime), '50');
      history.batchCallbacks.add(target, resolve);
    });
  };

  history.after = function (target, dateOrTime) {
    return new _promise.default(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }

      client.raw('CHATHISTORY', 'AFTER', target, messageReference(dateOrTime), '50');
      history.batchCallbacks.add(target, resolve);
    });
  };

  history.latest = function (target, dateOrTime) {
    return new _promise.default(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }

      client.raw('CHATHISTORY', 'LATEST', target, messageReference(dateOrTime), '50');
      history.batchCallbacks.add(target, resolve);
    });
  };

  history.around = function (target, dateOrTime) {
    return new _promise.default(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }

      client.raw('CHATHISTORY', 'AROUND', target, messageReference(dateOrTime), '50');
      history.batchCallbacks.add(target, resolve);
    });
  };

  history.between = function (target, fromDateOrTime, toDateOrTime) {
    return new _promise.default(function (resolve) {
      if (!history.isSupported()) {
        resolve();
        return;
      }

      var fromRef = messageReference(fromDateOrTime);
      var toRef = messageReference(toDateOrTime);
      client.raw('CHATHISTORY', 'BETWEEN', target, fromRef, toRef, 50);
      history.batchCallbacks.add(target, resolve);
    });
  };

  function messageReference(inp) {
    if ((0, _typeof2.default)(inp) === 'object') {
      return 'timestamp=' + Misc.dateIso(inp);
    }

    if (inp === '*') {
      return '*';
    }

    return 'msgid=' + inp;
  }
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ChathistoryMiddleware"]
window._kiwi_exports.libs.ChathistoryMiddleware = exports.default ? exports.default : exports;
